
    <h1 mat-dialog-title style="text-align:center;">End Day Warning</h1>
    <div mat-dialog-content>
      <p style="margin-bottom:12px;">You are attempting to end your day, however, the following jobs are still status <strong>"Scheduled"</strong>. Would you like to proceed with ending your day?</p>
      <table style="width:100%;border-collapse:collapse;font-size:13px;">
        <thead>
          <tr style="background:#f5f5f5;">
            <th style="padding:6px 8px;text-align:left;border-bottom:2px solid #ddd;">Location</th>
            <th style="padding:6px 8px;text-align:left;border-bottom:2px solid #ddd;">Address</th>
            <th style="padding:6px 8px;text-align:left;border-bottom:2px solid #ddd;">Job Type</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let job of jobs">
            <td style="padding:5px 8px;border-bottom:1px solid #eee;">{{job.subdivision_name}} Lot {{job.lot}}</td>
            <td style="padding:5px 8px;border-bottom:1px solid #eee;">{{job.street_address}}</td>
            <td style="padding:5px 8px;border-bottom:1px solid #eee;">{{job.customer_jobtype}}</td>
          </tr>
        </tbody>
      </table>
      <p style="margin-top:14px;font-size:12px;color:#888;">Your supervisor will be notified if you end your day with unresolved jobs.</p>
    </div>
    <div style="display:flex;justify-content:center;gap:12px;padding:16px;">
      <button mat-raised-button color="warn" (click)="dref.close(1)">End Day Anyway</button>
      <button mat-button (click)="dref.close(2)">Cancel</button>
    </div>
  